/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Components;
    (function (Components) {
        var ApLabeledTextInput = /** @class */ (function () {
            function ApLabeledTextInput() {
                this.bindings = {
                    /** optional a value indicating whether the input should have focus on load */
                    autoFocus: '@',
                    /** optional css class for control */
                    cssClass: '@',
                    /** optional max length for control */
                    maxLength: '<',
                    /** required model used as ng-model on control */
                    model: '=',
                    /** optional notification for when the user presses any key on the control - this returns an { arg: JQueryEventObject } */
                    onKeyPress: '&',
                    /** optional notification for when the user changes the value (ngBlur) - notice this is fired even if require validation fails */
                    onChange: '&',
                    /** typeahead options if the control supports this feature */
                    options: '<',
                    /** optional placeholder text for the control when no value is present */
                    placeholder: '@',
                    /** optional value that sets the control to readonly status when "true" */
                    readOnly: '@',
                    /** optional value that forces validation of user input to non null/whitespace strings - set control to "has-error" class but does NOT force user to enter valid input before leaving */
                    required: '@',
                    /** optional number of rows to be displayed if the control is to be a textarea rather than textbox */
                    rows: '@'
                };
                this.controller = Components.ApLabeledTextInputController;
                this.controllerAs = 'ctrl';
                this.templateUrl = 'app/components/ap-labeled-text-input/template.html';
                this.transclude = {
                    addOn: '?addOn',
                    text: '?text'
                };
            }
            return ApLabeledTextInput;
        }());
        angular
            .module('app.Components')
            .component('apLabeledTextInput', new ApLabeledTextInput());
    })(Components = app.Components || (app.Components = {}));
})(app || (app = {}));
